import { createSlice } from "@reduxjs/toolkit";
import { editAdminDetails, getAdminDetails, getAllClients, getClientDetailById, getClients, getReferralsLists } from "../Actions/auth";

const initialState = {
    loading: false,
    clientList: [],
    userDetail: [],
    allClientList: [],
    getReferralsData : []
}

const UserSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getClients.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.clientList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })

        // ==========================================================================================

        builder.addCase(getAdminDetails.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.adminDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })

        builder.addCase(editAdminDetails.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.adminDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        // ==========================================================================================

        builder.addCase(getClientDetailById.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.userDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })


        // ==========================================================================================

        builder.addCase(getAllClients.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.allClientList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })


        // ==========================================================================================

        builder.addCase(getReferralsLists.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.getReferralsData = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
    },
});

export default UserSlice.reducer;